import { createContext, useContext, useEffect, useRef, useState } from "react";
import { getSwagItems } from "../../../api/member/MemberDashboardAPI";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { checkSession, login } from "../../../api/login/UserLogin";
import UnauthorizedPage from "../../UnauthorizedPage";
import Page from "../../../components/Page";



const AdminSettingsContext = createContext();

export const AdminSettingsProvider = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);

    const intervalId = useRef(null);

    useEffect(() => {( async () => {
        try {
            setLoading(true);
            const allRoles = await checkSession(location.pathname, navigate);
            setRoles(allRoles);
            intervalId.current = setInterval(() => {
                checkSession(location.pathname, navigate);
            }, 15 * 60 * 1000); // every 15 min, check session
        } catch {
            login("/admin/settings");
        } finally {
            setLoading(false);
        }

        // Cleanup interval on unmount
        return () => clearInterval(intervalId.current);
    })();
    }, []);

    const correctRolesForPage = ["ADMIN", "LOGHEAD"].some(r => roles.includes(r));

    if (!correctRolesForPage && !loading) {
        return (
            <UnauthorizedPage />
        )
    }

    if (loading) {
        return (
            <Page>
                <div>
                    Loading...
                </div>
            </Page>
        )
    }

    return (
        // add values here
        <AdminSettingsContext.Provider value={{ }}>
            { children }
        </AdminSettingsContext.Provider>

    );

};

export const AdminSettingsLayout = () => {
    return (
        <AdminSettingsProvider>
            <Outlet />
        </AdminSettingsProvider>
    );

}

export const useAdminSettings = () => useContext(AdminSettingsContext);;